export default "__VITE_ASSET__iwVUuqI$__"